import type { ComponentPropsWithoutRef, ReactNode } from "react";
import AutoFocusAlert from "components/auto-focus-alert";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

type Props = {
  Title: ReactNode;
  Subtitle: ReactNode;
  children: ReactNode;
  error?: ComponentPropsWithoutRef<typeof AutoFocusAlert>["error"];
  className?: string;
};
const PaneLayout = ({ Title, Subtitle, children, error, className }: Props) => (
  <div className={getClasses(styles["pane-layout"], className)}>
    {error && <AutoFocusAlert error={error} />}
    <div className={styles["pane-layout__title"]}>{Title}</div>
    <div className={styles["pane-layout__subtitle"]}>{Subtitle}</div>
    <div className={styles["pane-layout__children"]}>{children}</div>
  </div>
);

export default PaneLayout;
